import {DISABLED, STEPS_GRAPH_CMS} from './StepConstants';
import {CALCULATOR, LOAN_APPLICATION, LOAN_APPLICATION_MX} from './LabelConstants';
import {COUNTRY_INITIALS, COUNTRY_NAME} from '../../common/constants/AppConstants';

export const HOST = `${window.location.protocol}//${window.location.host}`;
export const AUTOCOMPLETE_NOPE = 'nope';
export const AUTOCOMPLETE_NEW_PASSWORD = 'new-password';
const mainStep = [{
    id: '0',
    name: 'SIMULADOR DE CRÉDITO',
    visible: true,
    selected: DISABLED,

}, {
    id: '1',
    name: 'DATOS DE VALIDACIÓN CREDITICIA',
    visible: true,
    selected: DISABLED,

}, {
    id: '2',
    name: 'DATOS GENERALES',
    visible: true,
    selected: DISABLED,
}];

export const COUNTRIES = {
    MX: {
        mainStep,
        name: COUNTRY_NAME.MEXICO,
        id: COUNTRY_INITIALS.MEXICO,
        prefixMotorcredit: 'motorcredit-core-mexico/v7',
        prefixMotorcreditWithBank: 'motorcredit-core-mexico/{{bank}}/v1',
        totalSteps: 8,
        conciergePhone: '5541618830',
        locale: 'es-mx',
        securityClientId: 'motorcredit_for_dealer_mexico',
        bureauOptionIdCreditCardLastDigits: 3,
        noticeOfPrivacyUrl: 'https://mx.motorfy.com/legal/privacy/mobile',
        bureauTermsUrl: 'https://mx.motorfy.com/legal/bureau-term/mobile',
        termsAndConditionsUrl: 'https://mx.motorfy.com/legal/terms-and-conditions/mobile',
        totalReferences: 3,
        summaryStep: '9',
        facebookPageId: '1030269147372425',
        steps: [{
            id: '0',
            stepId: STEPS_GRAPH_CMS.STEP_STEP_0,
            name: CALCULATOR.VEHICLE_DATA,
            visible: true,
            selected: DISABLED,
            parentId: mainStep[0].id

        }, {
            id: '1',
            stepId: STEPS_GRAPH_CMS.STEP_STEP_1,
            name: LOAN_APPLICATION.APPLICANT_DATA,
            visible: true,
            selected: DISABLED,
            parentId: mainStep[1].id
        }, {
            id: '2',
            stepId: STEPS_GRAPH_CMS.STEP_STEP_2,
            name: LOAN_APPLICATION_MX.PRIVACY_AUTHORIZATION,
            visible: false,
            selected: DISABLED,
            parentId: mainStep[1].id
        }, {
            id: '3',
            stepId: STEPS_GRAPH_CMS.STEP_STEP_3,
            name: LOAN_APPLICATION_MX.ACTUAL_HOME,
            visible: true,
            selected: DISABLED,
            parentId: mainStep[1].id
        }, {
            id: '4',
            stepId: STEPS_GRAPH_CMS.STEP_STEP_4,
            name: LOAN_APPLICATION_MX.PRIVACY_AND_BUREAU_AUTHORIZATION,
            visible: false,
            selected: DISABLED,
            parentId: mainStep[1].id
        }, {
            id: '5',
            stepId: STEPS_GRAPH_CMS.STEP_STEP_5,
            name: LOAN_APPLICATION_MX.WORK_INFO,
            visible: true,
            selected: DISABLED,
            parentId: mainStep[2].id
        }, {
            id: '6',
            stepId: STEPS_GRAPH_CMS.STEP_STEP_6,
            name: LOAN_APPLICATION_MX.REFERENCES,
            visible: true,
            selected: DISABLED,
            parentId: mainStep[2].id
        }, {
            id: '7',
            stepId: STEPS_GRAPH_CMS.STEP_STEP_7,
            name: LOAN_APPLICATION_MX.INSURANCE,
            visible: false,
            selected: DISABLED,
            parentId: mainStep[2].id
        }, {
            id: '8',
            stepId: STEPS_GRAPH_CMS.STEP_STEP_8,
            name: LOAN_APPLICATION_MX.TITLE_FILE_UPLOAD,
            visible: true,
            selected: DISABLED,
            parentId: mainStep[2].id
        }]
    }
};
